
var id = "exitMeeting";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"exitMeeting\">\n<style type=\"text/css\">\n\t#exitMeeting .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#1B60AD;}\n</style>\n<title>34. Icons/filled/social/sentiment_dissatisfied_24px</title>\n<path class=\"st0\" d=\"M10.8,7.2C11.5,7.2,12,6.7,12,6s-0.5-1.2-1.2-1.2S9.6,5.3,9.6,6S10.1,7.2,10.8,7.2z M5.2,7.2\n\tc0.7,0,1.2-0.5,1.2-1.2S5.9,4.8,5.2,4.8S4,5.3,4,6S4.5,7.2,5.2,7.2z M8,9.6c-1.9,0-3.5,1.2-4.1,2.8h1.3c0.6-1,1.6-1.6,2.8-1.6\n\ts2.2,0.6,2.8,1.6h1.3C11.5,10.8,9.9,9.6,8,9.6z M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M8,14.4\n\tc-3.5,0-6.4-2.9-6.4-6.4S4.5,1.6,8,1.6s6.4,2.9,6.4,6.4S11.5,14.4,8,14.4z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
